import { rest } from 'msw'
import mockGetAllAddresses from '../../../__mocks__/ManageCryptoAddresses/addresses.json'

export const getAddresses = rest.get(
  `${API_URL}/api/v2/address/whitelist`,
  async (req, res, ctx) => {
    return res(ctx.json(mockGetAllAddresses))
  }
)

export const deleteCryptoAddress = rest.delete(
  `${API_URL}/api/v3/address/whitelist/:uuid`,
  async (req, res, ctx) => res(ctx.status(200))
)

export default [getAddresses, deleteCryptoAddress]
